import { Product } from '@/services/api/contracts/catalog/types';
import { Image, View } from '@react-pdf/renderer';
import { FunctionComponent } from 'react';
import { PdfCategoryIcons } from './PdfCategoryIcons';

interface PdfProductImageProps {
  product: Product;
}

const PdfProductImage: FunctionComponent<PdfProductImageProps> = ({ product }) => {
  return (
    <View
      style={{
        width: 50,
        height: 30,
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {product.imageUri?.id ? (
        <Image source={product.imageUri.thumbnail} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
      ) : (
        PdfCategoryIcons[product.category.description]
      )}
    </View>
  );
};

export default PdfProductImage;
